import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import ColorGenerator from "../pages/ColorGenerator";

function AllRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/ColorGenerator" element={<ColorGenerator />} />
    </Routes>
  );
}

export default AllRoutes;
